// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v5/activate_phone_number.proto

/* oxlint-disable */

/**
 * Request message for ActivatePhoneNumber (POST /v5/user/phone_number/activate).
 * Activates the pending phone number after OTP validation and MFA/SCA verification.
 * The activate endpoint has before_action :require_valid_new_phone_otp and :require_mfa_or_sca.
 */
export interface ApiActivatePhoneNumberRequest {
  /** The OTP code previously validated via validate_new_phone_otp. */
  readonly newPhoneOtp: string;
  /**
   * Optional MFA method ("by_sms" or "by_email"). Used only to verify the old-device
   * MFA/OTP header token (X-Qonto-MFA / X-Qonto-OTP) when SCA is not enabled.
   * Defaults to "by_sms" on the server if omitted. Not related to new_phone_otp validation.
   */
  readonly mfaMethod?: string | null | undefined;
}

/**
 * Response message for ActivatePhoneNumber.
 * Returns an empty body on success (200 OK).
 */
export interface ApiActivatePhoneNumberResponse {
}

export const ApiActivatePhoneNumberRequest: MessageFns<ApiActivatePhoneNumberRequest> = {
  fromJSON(object: any): ApiActivatePhoneNumberRequest {
    return {
      newPhoneOtp: isSet(object.new_phone_otp) ? globalThis.String(object.new_phone_otp) : "",
      mfaMethod: isSet(object.mfa_method) ? globalThis.String(object.mfa_method) : null,
    };
  },

  toJSON(message: ApiActivatePhoneNumberRequest): unknown {
    const obj: any = {};
    if (message.newPhoneOtp !== undefined && message.newPhoneOtp !== null) {
      obj.new_phone_otp = message.newPhoneOtp;
    }
    if (message.mfaMethod !== undefined && message.mfaMethod !== null) {
      obj.mfa_method = message.mfaMethod;
    }
    return obj;
  },
};

export const ApiActivatePhoneNumberResponse: MessageFns<ApiActivatePhoneNumberResponse> = {
  fromJSON(_: any): ApiActivatePhoneNumberResponse {
    return {};
  },

  toJSON(_: ApiActivatePhoneNumberResponse): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
